import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { mui } from '~/tools/mui';
import VisibilityAdornment from './VisibilityAdornment';
import PasswordStrengthChecker from './PasswordStrengthChecker';

// Password strength implementation inspired by
// https://github.com/mmw/react-password-strength/blob/master/src/index.js
const PasswordInput = ({
  name = 'pass',
  label = 'Password',
  margin = 'none',
  className = '',
  fullWidth = true,
  inputRef,
  inputProps = {},
  variant = 'standard',
  InputProps = {},
  InputLabelProps = {},
  error = false,
  helperText = '',
  minLength = undefined,
  minScore = undefined,
  userInputs = [],
  onChange = (e) => {},
  toggleVisibility = false,
  checkStrength = false,
  size,
}) => {
  // @ts-ignore @TODO Epic WT-21600
  PasswordInput.propTypes = {
    name: PropTypes.string,
    margin: PropTypes.string,
    fullWidth: PropTypes.bool,
    inputRef: PropTypes.any,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    toggleVisibility: PropTypes.bool,
    checkStrength: PropTypes.bool,
    size: PropTypes.string,
  };

  const [password, setPassword] = useState('');
  const [passwordInputType, setPasswordInputType] = useState('password');

  const onChangePassword = (e) => {
    const input = e.target.value;

    setPassword(input);

    onChange(e);
  };

  const togglePasswordVisibility = () => {
    if (passwordInputType === 'password') return setPasswordInputType('text');

    setPasswordInputType('password');
  };

  const passwordEndAdornment = toggleVisibility ? (
    <VisibilityAdornment inputType={passwordInputType} onClick={togglePasswordVisibility} />
  ) : null;

  return (
    <div>
      <mui.TextField
        size={size}
        type={passwordInputType}
        name={name}
        label={label}
        defaultValue={password}
        helperText={helperText}
        className={className}
        // @ts-ignore @TODO Epic WT-21600
        margin={margin}
        fullWidth={fullWidth}
        error={error}
        onChange={onChangePassword}
        inputRef={inputRef}
        inputProps={inputProps}
        // @ts-ignore @TODO Epic WT-21600
        variant={variant}
        InputProps={{
          ...InputProps,
          endAdornment: passwordEndAdornment,
        }}
        InputLabelProps={InputLabelProps}
      />

      {checkStrength && (
        <PasswordStrengthChecker
          password={password}
          userInputs={userInputs}
          minLength={minLength}
          minScore={minScore}
        />
      )}
    </div>
  );
};

export default PasswordInput;
